import { render, staticRenderFns } from "./ModuleStatus.vue?vue&type=template&id=16063fff&scoped=true&"
import script from "./ModuleStatus.vue?vue&type=script&lang=ts&"
export * from "./ModuleStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ModuleStatus.vue?vue&type=style&index=0&id=16063fff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16063fff",
  null
  
)

export default component.exports